import { createSlice } from "@reduxjs/toolkit"
import {
  deleteScheduleNotification,
  getAllPushNotifications,
  getNotificationHistory,
  getPushNotificationDetails,
  sendNotification,
  updatePushNotification,
  updatePushNotificationStatus,
} from "store/actions/pushNotificationAction"

const initialState = {
  loading: true,
  totalCount: null,
  totalPages: null,
  currentPage: 1,
  isLoading: false,
  isUpdating: false,
  itemsPerPage: 10,
  pushNotifications: [],
  pushNotificationDetails: {},
  notificationHistory: [],
}

const usersSlice = createSlice({
  name: "push notification",
  initialState,
  reducers: {},
  extraReducers: builder => {
    // GET ALL PROMOTIONS
    builder
      .addCase(getAllPushNotifications.pending, state => {
        state.loading = true
      })
      .addCase(getAllPushNotifications.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          const { totalCount, totalPages, currentPage } = action?.payload
          state.pushNotifications = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getAllPushNotifications.rejected, (state, action) => {
        state.loading = false
      })

    // UPDATE PUSH NOTIFICATION STATUS
    builder
      .addCase(updatePushNotificationStatus.pending, state => {
        state.isUpdating = true
      })
      .addCase(updatePushNotificationStatus.fulfilled, (state, action) => {
        state.isUpdating = false
        const { status } = action.payload
        if (status) {
          const { id, status } = action.meta.arg
          state.pushNotifications = state.pushNotifications.map(item =>
            item._id === id ? { ...item, status: Number(status) } : item
          )
        }
      })
      .addCase(updatePushNotificationStatus.rejected, (state, action) => {
        state.isUpdating = false
      })

    // GET PUSH NOTIFICATION DETAILS
    builder
      .addCase(getPushNotificationDetails.pending, state => {
        state.loading = true
        state.pushNotificationDetails = {}
      })
      .addCase(getPushNotificationDetails.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          state.pushNotificationDetails = data
        }
      })
      .addCase(getPushNotificationDetails.rejected, (state, action) => {
        state.loading = false
      })

    // UPDATE NOTIFICATION
    builder
      .addCase(updatePushNotification.pending, state => {
        state.isLoading = true
      })
      .addCase(updatePushNotification.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(updatePushNotification.rejected, (state, action) => {
        state.isLoading = false
      })

    //   SEND NOTIFICATION
    builder
      .addCase(sendNotification.pending, state => {
        state.isLoading = true
      })
      .addCase(sendNotification.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(sendNotification.rejected, (state, action) => {
        state.isLoading = false
      })

    //   GET NOTIFICATION HISTORY
    builder
      .addCase(getNotificationHistory.pending, state => {
        state.loading = true
      })
      .addCase(getNotificationHistory.fulfilled, (state, action) => {
        state.loading = false
        state.totalCount = null
        state.totalPages = null
        state.currentPage = null
        const { status, data } = action.payload
        if (status) {
          const { totalCount, totalPages, currentPage } = action?.payload
          state.notificationHistory = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getNotificationHistory.rejected, (state, action) => {
        state.loading = false
      })

    //   DELETE SCHEDULE NOTIFICATION
    builder
      .addCase(deleteScheduleNotification.pending, state => {
        state.isLoading = true
      })
      .addCase(deleteScheduleNotification.fulfilled, (state, action) => {
        const { status, msg } = action.payload
        const { id } = action.meta.arg
        state.isLoading = false
        if (status) {
          state.notificationHistory = state.notificationHistory.filter(
            item => item._id !== id
          )
          // Decrement the totalCount if it exists
          if (state.totalCount !== null) {
            state.totalCount -= 1
          }
        }
      })
      .addCase(deleteScheduleNotification.rejected, (state, action) => {
        state.isLoading = false
      })
  },
})

export default usersSlice.reducer
